import routesCommon from "./routesCommon";
import routesPersonal from "./routesPersonal";
import routesAI from "./routesAI";
import routesTeam from "./routesTeam";
import routesPublicSentiment from "./routesPublicSentiment";
import routesPublisher from "./routesPublisher";
import routesListening from "./routesListening";
import routersMarketionTool from "./routesMarketingTool";
import routesDataReport from "./routesDataReport";
import store from "@/store";


const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "LayoutIndex",
    component: () => import("@/views/Layout/Index.vue"),
    meta: {
      isLogin: true,
      title: "layout",
      crumbs: "JoinCompass ",
    },
    children: [
      {
        // 这个应该是工作台
        path: "/dashboard",
        redirect: "/platform",
        name: "dashboard",
        component: () => import("@/views/Layout/dashboard.vue"),
        meta: {
          title: "route.dashboard",
          crumbs: "route.dashboard-crumb",
          isLogin: true,
          // 主侧栏从路由 meta.sidebar 生成，工作台入口也保持在 router 单一来源中。
          // sidebar: { label: "工作台", icon: "Workbench", order: 0 },
        },
      },
      { // 套餐过期后的跳转目标，仅普通成员可进入
        path: "/team/package/expired",
        component: () => import("@/views/team/package/PackageExpired.vue"),
        meta: {
          isLogin: true,
          roles: [3],
        },
        beforeEnter: (to, from, next) => {
          // 仅套餐失效的普通成员可以停留在过期页，其余角色回到工作台
          const noValidPackage = store.getters["team/getPackageInvalid"];
          const role = Number(store.getters["authoState/current_team"]?.role);
          if (noValidPackage && role === 3) {
            next();
          } else {
            next("/dashboard");
          }
        },
      },
      ...routesPersonal,
      ...routesAI,
      ...routesTeam,
      ...routesPublicSentiment,
      ...routesPublisher,
      ...routesListening,
      ...routersMarketionTool,
      ...routesDataReport,
    ],
  },
  {
    path: "/bot/mail/reply",
    name: "botMailReply",
    component: () => import("@/views/bot/mailManage/reply.vue"),
    meta: {
      title: "route.mail-reply",
      crumbs: "route.mail-reply-crumb",
      isLogin: true,
    },
  },
  {
    path: "/document/use",
    name: "docUse",
    component: () => import("@/views/document/doc.vue"),
    meta: {
      title: "route.ai-writing",
      crumbs: "route.ai-writing-crumb",
      isLogin: true,
    },
  },
  {
    path: "/chatBotInsertion",
    name: "chatBotInsertion",
    component: () => import("@/views/chatBotInsertion/index.vue"),
    meta: {
      title: "route.ai-chatbot",
      crumbs: "route.ai-chatbot-crumb",
      isLogin: false,
    },
  },
  {
    path: "/chatBotInsertError",
    name: "chatBotInsertError",
    component: () => import("@/views/chatBotInsertion/error.vue"),
    meta: {
      title: "route.ai-chatbot",
      crumbs: "route.ai-chatbot-crumb",
      isLogin: false,
    },
  },
  ...routesCommon,
  {
    path: "/youtubeAuthCallback",
    name: "YouTubeAuthCallbackPage",
    component: () => import("@/views/publicSentiment/socialMedia/YouTubeAuthCallbackPage.vue"),
    meta: {
      title: "JoinCompass - YouTube Authorization",
      isLogin: false,
    },
  },
];

export default routes;
